import React from 'react';
import { styled } from 'linaria/react';
import Image from 'next/image';
import { DEFAULT_LOCATION } from './constants';
const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "wnrhoix"
});
const Title = /*#__PURE__*/styled("h2")({
  name: "Title",
  class: "t1gy7sqq"
});
const Item = /*#__PURE__*/styled("li")({
  name: "Item",
  class: "iws5vzr"
});
const WrapperCat = /*#__PURE__*/styled("div")({
  name: "WrapperCat",
  class: "w1mkj27i"
});
const ImgParent = /*#__PURE__*/styled("div")({
  name: "ImgParent",
  class: "i5ej9zg"
});
const CategoryImg = /*#__PURE__*/styled("div")({
  name: "CategoryImg",
  class: "c17lw2jw"
});
const A = /*#__PURE__*/styled("a")({
  name: "A",
  class: "azmhcbw"
});
const Company = ({
  services = [],
  region: regionLocation,
  onClick,
  isDone
}) => {
  return isDone && services.length > 0 ? <Wrapper>
      <Title>Việc làm theo công ty</Title>
      <WrapperCat>
        {services.map((item, index) => {
        const regionString = `${regionLocation?.regionUrl}${regionLocation?.subRegionUrl ? '/' + regionLocation?.subRegionUrl : ''}${regionLocation?.wardUrl ? '/' + regionLocation?.wardUrl : ''}`;
        const url = `${item?.use_local_region ? item?.web_url?.replace(DEFAULT_LOCATION, regionString) : item?.web_url}`;
        item.index = index + 1;
        return <Item key={'cat-' + index.toString()}>
              <A aria-label={item.text} onClick={() => onClick(item)} href={url}>
                {/* <Overlay> */}
                <ImgParent>
                  <CategoryImg>
                    <Image src={item.image} alt={'cat-' + index.toString()} width={70} height={70} loading="lazy" />
                  </CategoryImg>
                </ImgParent>
                {/* <div className="flex flex-col flex-auto">
                  <CategoryText>{item.text || ''}</CategoryText>
                  <CategorySubText>{item.sub_text || ''}</CategorySubText>
                 </div> */}
                {/* </Overlay> */}
              </A>
            </Item>;
      })}
      </WrapperCat>
    </Wrapper> : null;
};
export default Company;

require("../../../.linaria-cache/src/components/Company/index.linaria.module.css");